export default __webpack_public_path__ + "static/media/Yellow0005.47509912.png";